

import claquetaSvg from './Claqueta.svg?raw';

const prepareClaquetaSvg = () => {
    const parser = new DOMParser();
    const document = parser.parseFromString(claquetaSvg, 'image/svg+xml');
    document.getElementById('background_claqueta')?.setAttribute('class', 'background');
    document.getElementById('doesnt_move_motivos_claqueta')?.setAttribute('class', 'drawing_doesnt_move');

    return new XMLSerializer().serializeToString(document);
}


export const dogBaseLayout = () => {
    const svg =  `
    <svg
       viewBox="0 0 29.584551 17.320898"
       version="1.1"
       id="svg1"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:svg="http://www.w3.org/2000/svg">
      <defs
         id="defs1" />
      <path
         fill="#808080"
         d="m 29.584551,5.7702327 c 0,1.077033 -0.288602,2.087143 -0.791567,2.958181 A 5.9151639,5.9151639 0 1 1 17.941092,13.164117 H 11.652474 A 5.9181214,5.9181214 0 1 1 0.8005823,8.7284137 5.9151639,5.9151639 0 1 1 11.652474,4.2927107 l 6.288618,-0.0021 a 5.9181214,5.9181214 0 0 1 11.643459,1.479614"
         id="path2970"
         stroke-width="0"
         style="" />
    </svg>

    `;
    const width = 79;
    const height = 44;

    return {svg: svg, width: width, height: height};
}

export const squareBaseLayout = () => {

    const svg = `
    <svg width="50mm" height="50mm" xmlns="http://www.w3.org/2000/svg" id="background_square">
        <rect id="background_square" x="50" y="50" width="50mm" height="50mm" fill="none" stroke="none" stroke-width="0"/>
    </svg>
    `;


    const width = 46;
    const height = 46;

    return {svg: svg, width: width, height: height};

}


export const circleBaseLayout = () => {

    const svg = `
    <svg
       width="70mm"
       height="70mm"
       viewBox="0 0 76.525421 76.525421"
       id="background_circle"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:svg="http://www.w3.org/2000/svg">
    
        <path
           style="opacity:1;stroke-width:0"
           d="m 164.61864,159.27966 c 0,1.32074 -0.0669,2.62586 -0.19755,3.91214 -0.13063,1.28628 -0.32497,2.55372 -0.57981,3.79913 -0.25485,1.2454 -0.5702,2.46877 -0.94286,3.66689 -0.37265,1.19812 -0.80261,2.37099 -1.28665,3.51541 -0.48406,1.14442 -1.0222,2.26039 -1.61123,3.34471 -0.58904,1.08431 -1.22896,2.13697 -1.91657,3.15476 -0.68761,1.0178 -1.42291,2.00073 -2.20267,2.94559 -0.77978,0.94487 -1.60403,1.85166 -2.46955,2.71719 -0.86553,0.86552 -1.77232,1.68977 -2.71719,2.46955 -0.94486,0.77977 -1.92779,1.51506 -2.94559,2.20267 -1.01779,0.68761 -2.07045,1.32753 -3.15476,1.91657 -1.08432,0.58903 -2.20029,1.12717 -3.34471,1.61123 -1.14442,0.48405 -2.3173,0.914 -3.51541,1.28665 -1.19812,0.37266 -2.42149,0.68801 -3.66689,0.94286 -1.24541,0.25484 -2.51285,0.44918 -3.79913,0.57981 -1.28628,0.13063 -2.5914,0.19755 -3.91214,0.19755 -1.32074,0 -2.62586,-0.0669 -3.91214,-0.19755 -1.28628,-0.13063 -2.55372,-0.32497 -3.79913,-0.57981 -1.24541,-0.25485 -2.46877,-0.5702 -3.66689,-0.94286 -1.19812,-0.37265 -2.37099,-0.8026 -3.51541,-1.28665 -1.14442,-0.48406 -2.26039,-1.0222 -3.34471,-1.61123 -1.08431,-0.58904 -2.13697,-1.22896 -3.15477,-1.91657 -1.01779,-0.68761 -2.00072,-1.4229 -2.94559,-2.20267 -0.94486,-0.77977 -1.85166,-1.60402 -2.717184,-2.46955 -0.865523,-0.86552 -1.689773,-1.77232 -2.469545,-2.71719 -0.779771,-0.94486 -1.515065,-1.92779 -2.202673,-2.94559 -0.687609,-1.01779 -1.327533,-2.07045 -1.916568,-3.15476 -0.589034,-1.08432 -1.127179,-2.20029 -1.611229,-3.34471 -0.484049,-1.14442 -0.914004,-2.31729 -1.286658,-3.51541 -0.372654,-1.19812 -0.688006,-2.42149 -0.942853,-3.66689 -0.254847,-1.24541 -0.449188,-2.51285 -0.579817,-3.79913 -0.130629,-1.28628 -0.197546,-2.5914 -0.197546,-3.91214 0,-1.32074 0.06692,-2.62586 0.197546,-3.91214 0.130629,-1.28628 0.32497,-2.55372 0.579816,-3.79913 0.254847,-1.2454 0.5702,-2.46877 0.942854,-3.66689 0.372654,-1.19812 0.802608,-2.37099 1.286658,-3.51541 0.484049,-1.14442 1.022194,-2.26039 1.611229,-3.34471 0.589034,-1.08431 1.228959,-2.13697 1.916567,-3.15476 0.687609,-1.0178 1.422902,-2.00073 2.202673,-2.94559 0.779772,-0.94487 1.604022,-1.85167 2.469546,-2.71719 0.865524,-0.86553 1.772324,-1.68978 2.717184,-2.46955 0.94487,-0.77977 1.9278,-1.51506 2.94559,-2.20267 1.0178,-0.68761 2.07046,-1.32753 3.15477,-1.91657 1.08431,-0.58903 2.20029,-1.12717 3.34471,-1.61123 1.14442,-0.48405 2.31729,-0.914 3.51541,-1.28665 1.19812,-0.37266 2.42148,-0.68801 3.66689,-0.94286 1.24541,-0.25484 2.51285,-0.44918 3.79913,-0.57981 1.28628,-0.13063 2.5914,-0.19755 3.91214,-0.19755 1.32074,0 2.62586,0.0669 3.91214,0.19755 1.28628,0.13063 2.55372,0.32497 3.79913,0.57981 1.2454,0.25485 2.46877,0.5702 3.66689,0.94286 1.19811,0.37265 2.37099,0.8026 3.51541,1.28665 1.14442,0.48406 2.26039,1.0222 3.34471,1.61123 1.08431,0.58904 2.13697,1.22896 3.15476,1.91657 1.0178,0.68761 2.00073,1.4229 2.94559,2.20267 0.94487,0.77978 1.85167,1.60403 2.71719,2.46955 0.86552,0.86553 1.68977,1.77232 2.46955,2.71719 0.77976,0.94486 1.51506,1.92779 2.20267,2.94559 0.68761,1.01779 1.32753,2.07045 1.91657,3.15476 0.58903,1.08432 1.12717,2.20029 1.61123,3.34471 0.48404,1.14442 0.914,2.31729 1.28665,3.51541 0.37266,1.19812 0.68801,2.42149 0.94286,3.66689 0.25484,1.24541 0.44918,2.51285 0.57981,3.79913 0.13063,1.28628 0.19755,2.5914 0.19755,3.91214 z" />
    </svg>
    `;


    const width = 45;
    const height = 45;

    return {svg: svg, width: width, height: height};
}

export const heartBaseLayout = () => {
    const svg = `
        
        
        <svg
           width="63.774158mm"
           height="56.687912mm"
           id="background_heart"
           viewBox="0 0 7.941796 5.2289875"
           xmlns="http://www.w3.org/2000/svg"
           >
          <path
             fill="#000000"
             stroke="none"
             stroke-width="0"
             d="M 3.970898,6.1441656 C 3.9041176,6.14424 3.8381915,6.1291543 3.778089,6.1000456 3.7395932,6.0812938 3.4842148,5.9553003 3.122801,5.7308686 2.7613872,5.5064369 2.2939381,5.1835669 1.8313009,4.7710622 1.3686637,4.3585575 0.91083847,3.8564181 0.56867255,3.2734475 0.22650663,2.6904769 0,2.0266751 0,1.2908456 6.6516725e-6,0.79954321 0.14850449,0.3695467 0.39296348,0.02261896 0.63742247,-0.32430878 0.97784262,-0.58816775 1.3616939,-0.74719507 c 0.3838513,-0.15902732 0.8111337,-0.21322299 1.2293172,-0.14082414 0.4181836,0.0723988 0.8272682,0.27139223 1.1747239,0.61874302 l 0.205163,0.205163 0.205163,-0.205163 c 0.3474557,-0.34735078 0.7565404,-0.54634415 1.1747239,-0.618743 0.4181835,-0.0723989 0.8454659,-0.0182032 1.2293172,0.14082414 0.3838513,0.15902732 0.7242714,0.42288628 0.9687304,0.76981402 0.244459,0.34692773 0.3929568,0.77692423 0.3929635,1.26822663 0,0.7330717 -0.2264515,1.3954395 -0.5685416,1.977824 C 7.0311642,3.8510542 6.5734355,4.3534555 6.110881,4.7665943 5.6483265,5.1797332 5.1809462,5.5036097 4.8195531,5.7289444 4.45816,5.9542792 4.202754,6.0810723 4.164148,6.1000446 4.103912,6.1292186 4.0378273,6.1443066 3.970898,6.1441656 Z"
          />
        </svg>
    `


    const width = 65;
    const height = 57;

    return {svg: svg, width: width, height: height};
}
export const matriculaBaseLayout = () => {
    const svg = `
<svg
   width="147.05121mm"
   height="40.565861mm"
   viewBox="0 0 147.05121 40.565861"
   version="1.1"
   id="svg5"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs2" />
  <g
     id="layer2"
     transform="translate(-43.810543,-120.24878)" />
  <g
     id="layer1"
     transform="translate(-43.810543,-120.24878)">
    <path
       id="background_placa"
       class="background"
       style="opacity:1;fill:#ffffff;stroke-width:0.992"
       d="M 46.219635,120.24878 H 188.45266 c 1.33464,0 2.40909,0.99312 2.40909,2.22673 v 36.1124 c 0,1.2336 -1.07445,2.22673 -2.40909,2.22673 H 46.219635 c -1.334637,0 -2.409092,-0.99313 -2.409092,-2.22673 v -36.1124 c 0,-1.23361 1.074455,-2.22673 2.409092,-2.22673 z" />
    <path
       id="doesnt_move_azul_europa"
       class="drawing_doesnt_move"
       style="opacity:0.77;fill:#0000ff;stroke-width:1.00209"
       d="m 46.288747,121.11821 h 13.522479 c 0.808866,0 1.464582,0.65571 1.464585,1.46458 v 35.89784 c -3e-6,0.80887 -0.655719,1.46458 -1.464585,1.46458 H 46.288747 c -0.808866,0 -1.464582,-0.65571 -1.464585,-1.46458 v -35.89784 c 3e-6,-0.80887 0.655719,-1.46458 1.464585,-1.46458 z" />
  </g>
</svg>


    `

    const width = 147;
    const height = 41;

    return {svg: svg, width: width, height: height};
}

export const capsuleBaseLayout = () => {
    const svg = `
        <svg
           width="80mm"
           height="35mm"
           viewBox="0 0 80 35"
           version="1.1"
           id="background_capsule"
           xmlns="http://www.w3.org/2000/svg"
           xmlns:svg="http://www.w3.org/2000/svg">
          <rect
             id="background_capsule"
             x="1"
             y="1"
             width="78"
             height="33"
             rx="16.5"
             ry="16.5"
             fill="#ffffff"
             stroke="none"
             stroke-width="0" />
        </svg>
    `;

    const width = 80;
    const height = 35;

    return {svg: svg, width: width, height: height};
}

export const DEFAULT_PLANT_TAG_PARAMS = {
    plateWidth: 80,
    plateHeight: 24,
    stakeWidth: 5,
    stakeHeight: 90,
};

const clampPlantTagValue = (value, fallback, min, max) => {
    const number = Number(value);
    return Number.isFinite(number) ? Math.min(max, Math.max(min, number)) : fallback;
};

export const normalizePlantTagParams = (params = {}) => ({
    plateWidth: clampPlantTagValue(params.plateWidth, DEFAULT_PLANT_TAG_PARAMS.plateWidth, 30, 200),
    plateHeight: clampPlantTagValue(params.plateHeight, DEFAULT_PLANT_TAG_PARAMS.plateHeight, 12, 80),
    stakeWidth: clampPlantTagValue(params.stakeWidth, DEFAULT_PLANT_TAG_PARAMS.stakeWidth, 2, 20),
    stakeHeight: clampPlantTagValue(params.stakeHeight, DEFAULT_PLANT_TAG_PARAMS.stakeHeight, 25, 250),
});

export const plantTagBaseLayout = (params = {}) => {
    const { plateWidth, plateHeight, stakeWidth, stakeHeight } = normalizePlantTagParams(params);
    const centerX = plateWidth / 2;
    const cornerRadius = Math.min(4, plateHeight / 5);
    const shoulderWidth = Math.min(plateWidth * 0.28, Math.max(stakeWidth + 10, stakeWidth * 3));
    const shoulderHalf = shoulderWidth / 2;
    const stakeHalf = Math.min(stakeWidth, plateWidth - 4) / 2;
    const transitionHeight = Math.min(12, plateHeight * 0.45, stakeHeight * 0.18);
    const tipHeight = Math.min(14, Math.max(7, stakeWidth * 2), stakeHeight * 0.25);
    const straightEndY = plateHeight + stakeHeight - tipHeight;
    const totalHeight = plateHeight + stakeHeight;

    // Una sola silueta cerrada: la placa, los hombros y la estaca se extruyen
    // como una pieza continua, sin depender de uniones posteriores.
    const path = [
        `M ${cornerRadius},0`,
        `H ${plateWidth - cornerRadius}`,
        `Q ${plateWidth},0 ${plateWidth},${cornerRadius}`,
        `V ${plateHeight - cornerRadius}`,
        `Q ${plateWidth},${plateHeight} ${plateWidth - cornerRadius},${plateHeight}`,
        `H ${centerX + shoulderHalf}`,
        `L ${centerX + stakeHalf},${plateHeight + transitionHeight}`,
        `V ${straightEndY}`,
        `L ${centerX},${totalHeight}`,
        `L ${centerX - stakeHalf},${straightEndY}`,
        `V ${plateHeight + transitionHeight}`,
        `L ${centerX - shoulderHalf},${plateHeight}`,
        `H ${cornerRadius}`,
        `Q 0,${plateHeight} 0,${plateHeight - cornerRadius}`,
        `V ${cornerRadius}`,
        `Q 0,0 ${cornerRadius},0 Z`,
    ].join(' ');

    const svg = `
        <svg
           width="${plateWidth}mm"
           height="${totalHeight}mm"
           viewBox="0 0 ${plateWidth} ${totalHeight}"
           version="1.1"
           id="svg_plant_tag"
           xmlns="http://www.w3.org/2000/svg">
          <path
             id="background_plant_tag"
             class="background"
             fill="#ffffff"
             stroke="none"
             stroke-width="0"
             d="${path}" />
        </svg>
    `;

    return { svg, width: plateWidth, height: totalHeight, params: { plateWidth, plateHeight, stakeWidth, stakeHeight } };
};

// Bocadillo de cómic: la elipse blanca interior es el lienzo donde se escribe;
// el contorno (anillo) y la cola son drawing_doesnt_move (fijos, se extruyen como color).
export const comicBubbleBaseLayout = () => {
    const svg = `
        <svg
           width="80mm"
           height="64mm"
           viewBox="0 0 80 64"
           version="1.1"
           id="svg_comic"
           xmlns="http://www.w3.org/2000/svg"
           xmlns:svg="http://www.w3.org/2000/svg">
          <path
             id="background_bubble"
             class="background"
             style="fill:#ffffff;stroke-width:0"
             d="M 5,28 a 35,23 0 1 0 70,0 a 35,23 0 1 0 -70,0 Z" />
          <path
             id="doesnt_move_outline"
             class="drawing_doesnt_move"
             fill-rule="evenodd"
             style="fill:#1f1f1f;stroke-width:0"
             d="M 2,28 a 38,26 0 1 0 76,0 a 38,26 0 1 0 -76,0 Z M 5,28 a 35,23 0 1 0 70,0 a 35,23 0 1 0 -70,0 Z" />
          <path
             id="doesnt_move_tail"
             class="drawing_doesnt_move"
             style="fill:#1f1f1f;stroke-width:0"
             d="M 30,49 L 46,49 L 26,62 Z" />
        </svg>
    `;

    const width = 80;
    const height = 64;

    return {svg: svg, width: width, height: height};
}

// Placa de casa con número: la placa redondeada blanca es el lienzo (se escribe el número);
// la silueta de la casa arriba es drawing_doesnt_move (fija, se extruye como color).
export const casaPlacaBaseLayout = () => {
    const svg = `
        <svg
           width="80mm"
           height="60mm"
           viewBox="0 0 80 60"
           version="1.1"
           id="svg_casa"
           xmlns="http://www.w3.org/2000/svg"
           xmlns:svg="http://www.w3.org/2000/svg">
          <path
             id="background_placa_casa"
             class="background"
             style="fill:#ffffff;stroke-width:0"
             d="M 8,2 H 72 a 6,6 0 0 1 6,6 V 52 a 6,6 0 0 1 -6,6 H 8 a 6,6 0 0 1 -6,-6 V 8 a 6,6 0 0 1 6,-6 Z" />
          <path
             id="doesnt_move_casa"
             class="drawing_doesnt_move"
             style="fill:#b03a2e;stroke-width:0"
             d="M 40,7 L 54,18 L 50,18 L 50,32 L 30,32 L 30,18 L 26,18 Z" />
        </svg>
    `;

    const width = 80;
    const height = 60;

    return {svg: svg, width: width, height: height};
}

export const claquetaBaseLayout = () => {
    const width = 80;
    const height = 81;

    return {svg: prepareClaquetaSvg(), width: width, height: height};
}

/**
 * Lookup by layout key, so callers do not need a switch statement.
 *
 * Adding a layout used to mean editing four files (this one, the Customizer's
 * switch, the shape list in ToolSelectorRight and the icon set). With this map
 * plus the per-product `layouts` list in products/registry.js it is down to
 * this file and Icons.jsx.
 */
export const LAYOUT_BUILDERS = {
    square: squareBaseLayout,
    circle: circleBaseLayout,
    dog: dogBaseLayout,
    heart: heartBaseLayout,
    matricula: matriculaBaseLayout,
    capsule: capsuleBaseLayout,
    plant_tag: plantTagBaseLayout,
    comic: comicBubbleBaseLayout,
    casa: casaPlacaBaseLayout,
    claqueta: claquetaBaseLayout,
};

export const buildBaseLayout = (key, params) => LAYOUT_BUILDERS[key]?.(params) ?? null;
